var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c("router-view"),
      _c("simplert", { ref: "simplert", staticClass: "simplert" }),
      _c("e-spinner", { attrs: { loading: _vm.$store.state.LoadingStatus } }),
      _vm.isLocalMode && _vm.$store.getters["auth/jwt"]
        ? _c(
            "div",
            {
              staticStyle: {
                position: "fixed",
                right: "10px",
                bottom: "10px",
                "z-index": "999999",
                background: "rgba(0,0,0,.75)",
                color: "#0f0",
                font: "13px/1.4 monospace",
                padding: "6px 10px",
                "border-radius": "4px",
                "pointer-events": "none",
              },
            },
            [_vm._v(" 로그아웃까지 " + _vm._s(_vm.remainText) + " ")]
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }